import $ from 'jquery';
import { Modal } from 'bootstrap';
window.$ = window.jQuery = $;
window.Modal = Modal;

import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/droppable.js';
import 'jquery-ui/ui/widgets/sortable.js';
import './bootstrap';
import './nav';
import './ajax';
import './slots';
import './booking-form';
import './dates';
import './diary';
import 'select2';
import './edit-booking';
import './sorting';
import './admin';
import './charts';

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
